// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__cuoDQ","banner-tagline":"Banner_banner-tagline__ntvTM","updown":"Banner_updown__v5lBl","txt-rotate":"Banner_txt-rotate__UCvh+","wrap":"Banner_wrap__bO6MT"};